export default {
  rights: {
    title: "権限管理",
    operatorManage: "オペレーター管理",
    roleManage: "ロール管理",
    groupLabel: "グループ",
    roleLabel: "ロール",
    statusLabel: "ステータス",
    nameLabel: "名前",
    usernameLabel: "ログインID",
    phoneLabel: "電話番号",
    emailLabel: "メールアドレス",
    createNewOperator: "オペレーター追加",
    search: "検索",
    clear: "リセット",
    lastLoginTime: "最終ログイン日時",
    operator: "担当者",
    action: "操作",
    detail: "詳細",
    notAssigned: "割り当てられていません",
    seeAll: "全て",
    collapse: "近い",
    all: "全て",
    statusTrue: "有効",
    statusFalse: "無効にする",
    phoneEmail: "電話番号 / メールアドレス",
    roleName: "ロール名",
    createNewRole: "ロール追加",
    roleDesc: "ロール説明",
    updateTime: "更新日時",
    delete: "削除",
    tips: "この演算子を無効にしてもよろしいですか?オペレーターはバックエンドにログインできなくなりますか?",
    tips1: "この演算子を有効にしてもよろしいですか?",
    displayOp: "オペレータを無効にする",
    enabledOp: "演算子を有効にする",
    enabled: "有効",
    sure: "無効にする",
    cancel: "キャンセル",
    tips2: "役割の削除",
    tips3: "この役割を削除してもよろしいですか?",
    tips4: "このロールはオペレーターによっても使用されます。このロールを削除することを確認します。",
    tipTitle: "ヒント"
  },
  detail: {
    operatorDetail: "オペレーター詳細",
    resetPassword: "パスワードをリセットする",
    editOperator: "編集演算子",
    delOperator: "演算子の削除",
    delOperatorTip: "この操作によりオペレーターが削除されます。続けますか?",
    operatorName: "オペレーター名",
    affiliatedGroup: "グループ",
    roleInfo: "役割情報",
    create: "作成日時",
    roleDetail: "役割の詳細",
    roleManage: "ロール管理",
    rolePermission: "役割の権限",
    operatorInfo: "運営者情報",
    edit: "編集"
  },
  edit: {
    editOperator: "編集演算子",
    createOperator: "オペレーター追加",
    basicInfo: "基本情報",
    tips: "オペレーターは、割り当てられたグループのデータのみ閲覧可能です。",
    allgroups: "全グループ",
    tips2: "※このオプションには、今後作成されるグループも含まれます。",
    groupNotAssigned: "未割当グループ",
    groupAssigned: "割当済グループ",
    roleInfo: "役割情報",
    tips3: "ロールを割り当てることで、オペレーターに該当ロールの権限が付与されます。",
    save: '保存',
    cancel: "キャンセル",
    create: "作成する",
    tips4: "※追加後、オペレーター名は変更できません。",
    password: "パスワード",
    repeatPassword: "パスワードを再度入力してください。",
    errorPwd: "パスワードは英語で始まり、任意の 2 種類の数字と大文字と小文字を含み、長さは 6 ～ 20 文字である必要があります。",
    errorName: "名前を入力してください",
    errorUsername: "ログイン名を入力してください",
    errorPhone: "携帯電話番号を入力してください",
    errorPhoneRNM: "正しい携帯電話番号を入力してください",
    errorEmail: "メールアドレスを入力してください",
    errorEmailFm: "正しい電子メール形式を入力してください",
    errorPassword: "パスワードを入力してください",
    errorRepeatPassword: "パスワード（確認用）",
    errorRoleName: "ロール名を入力してください",
    errorRoleDesc: "役割の説明を入力してください",
    difPassword: "パスワードが一致しません。",
    saveSuccess: "正常に保存されました",
    addSuccess: "正常に追加されました",
    delSuccess: "正常に削除されました",
    editRole: "役割の編集",
    createRole: "ロール作成",
    tip5: "権限はボタンレベルで設定可能です。権限が付与されていない場合、オペレーターはそのボタンをクリックまたは操作できません。権限を追加すると、対応するページの表示および操作権限が付与されます。",
    resetPwd: "パスワードをリセットする",
    newPwd: "新しいパスワード",
    confirmPwd: "パスワード（確認用）",
    reset: "リセット",
    checkAll: "すべて選択",
    roles: "ロール割り当て",
    repeatName: "オペレーター名が重複しています",
    repeatLogin: "ログイン名が重複しています",
    repeatPhone: "携帯電話番号が重複しています",
    repeatEmail: "メールアドレスが重複しています",
    editSuccess: "パスワードの再設定が完了しました"
  }
};
